var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{attrs:{"fixed-header":"","headers":_vm.columns,"items":_vm.items,"items-per-page":-1,"hide-default-footer":true,"keep-filters":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }